import React from 'react';
import { array, string, func, bool } from 'prop-types';

import Plan from './Plan';

const Plans = ({ list, setActive, onclickPlan, ...props }) => {
  const onSelectPlan = (plan, price) => () =>
    setActive({
      ...plan,
      price
    });

  return (list || []).map((plan, index) => {
    const price = plan.yearlyPrice.perYear;
    return (
      <Plan
        onclickPlan={onclickPlan}
        key={`${plan.id}-${index}`}
        {...plan}
        price={price}
        selectPlan={onSelectPlan(plan, price)}
        {...props}
      />
    );
  });
};

Plans.propTypes = {
  list: array,
  setActive: func,
  t: func,
  disabled: bool,
  onclickPlan: func
};

export default Plans;
